<template>
     <div class="px-6 md:px-10 py-10 rounded-lg dark:text-white third_color_dark_bg ">    <!-- mx-10 -->
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 ">

                <div>
                    <h2 class="text-3xl font-bold mb-5 dark:text-white"> {{ $t("emailSubscription.signup") }} </h2>
                    <p class="mb-8 dark:text-white" v-html="email_description"></p>
                </div>

                <form @submit.prevent="subscribe" class="flex justify-center flex-col" id="newsletterForm">
                    <div class="flex mb-4 items-start w-full ">
                        <input v-model="email" type="email" class="text-primary border-none rounded-l-md py-3 px-4 w-full focus:outline-none max-w-[500px]" :placeholder="$t('emailSubscription.emailPlaceholder')" required/>
                        <button :disabled="loading" class="btn-primary font-bold py-3 px-6 rounded-r-md dark:text-white  bg-primary flex items-center gap-4">
                            <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                            <span>{{ loading ? $t('emailSubscription.subscribing') : $t('emailSubscription.subscribe') }}</span>
                        </button>
                    </div>
                    <div v-if="message" class="pb-4">
                        {{ message }}
                    </div>

                    <p class="text-sm dark:text-white">
                        {{ $t('emailSubscription.privacy_cookie') }}
                        <a href="/privacy" class="hover:underline">{{ $t('emailSubscription.privacy_cookie_link') }}</a>
                    </p>
                </form>
            </div>
        </div>
</template>

<script>

export default {

    data() {
        return {
            email: "",
            message: '',
            success: false,
            loading: false,
            email_description: null,
        };
    },

    mounted() {
        const clientVars = this.$attrs.clientvariables ? JSON.parse(this.$attrs.clientvariables) : {};
        this.email_description = Array.isArray(clientVars.email_description)
            ? clientVars.email_description.join(' ').trim()
            : (clientVars.email_description || '').trim();
    },

    methods: {
        async subscribe() {
            this.loading = true;
            try {
                // Get CSRF token from meta tag
                const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

                const response = await fetch('/api/mailchimp/subscribe', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrfToken, // <-- add CSRF token
                    },
                    body: JSON.stringify({
                        email: this.email,
                        language: this.$i18n.locale
                    }),
                    credentials: 'include' // ensure cookies are sent
                });

                const text = await response.text(); // Read as text first
                let result;
                try {
                    result = JSON.parse(text); // Try parsing JSON
                } catch (e) {
                    console.error("Invalid JSON:", text);
                    throw new Error("Received invalid JSON from the server.");
                }

                if (response.status === 200 && result.success) {
                    this.success = true;
                    this.message = result.message;
                    this.email = '';
                } else {
                    this.success = false;
                    this.message = result.message || 'There was an error processing your request. Please try again later.';
                }
            } catch (error) {
                this.success = false;
                this.message = error.message;
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>